import { Injectable, Injector } from '@angular/core';
import { SortOption } from '@core';
import { Observable } from 'rxjs';
import { DocListBaseService } from 'src/app/shared-feature/services/_base/doc-list-base.service';

@Injectable()
export class InvoiceListService extends DocListBaseService {
  url = 'api/invoices/list';
  expandProperties = '';
  override searchColumns: string[] = [
    'DocCode',
    'Description',
    'CustomerCode',
    'CustomerName',
    'AgentCode',
    'TermCode'
  ];
  sortOptions: SortOption[] = [
    { title: 'Date', sort: 'docDate' },
    { title: 'Doc #', sort: 'docCode' },
    { title: 'Customer #', sort: 'CustomerCode' },
    { title: 'Customer Name', sort: 'CustomerName' },
    { title: 'Agent #', sort: 'AgentCode' },
    { title: 'Term', sort: 'TermCode' },
    { title: 'Due Date', sort: 'DueDate' }
  ];

  override onAction(action: string, data: any): Promise<boolean> {
    if (action === 'delete') {
      return this.confirmClearKnockoffIfAny(data.map((x: any) => x.id));
    }
    if (action === 'matchToAROR') {
      return this.confirmValidToKnockoff(data.map((x: any) => x.id));
    }
    return super.onAction(action, data);
  }

  confirmClearKnockoffIfAny(ids: any[]): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.http
        .post('api/Invoices/IsBatchKnockedoff', { ids: ids }, { _silent: true })
        .subscribe(res => {
          if (res === true) {
            const modalRef = this.modalService.confirm({
              nzTitle: 'Delete Record(s)?',
              nzContent:
                '<b>Invoice(s) is already knocked-off. Matched data will be cleared.</b>',
              nzOkText: 'Proceed',
              nzOkType: 'primary',
              nzOnOk: () => {
                resolve(true);
                modalRef.destroy();
              },
              nzCancelText: 'Cancel',
              nzOnCancel: () => {
                reject();
                modalRef.destroy();
              }
            });
          } else {
            resolve(true);
          }
        });
    });
  }

  confirmValidToKnockoff(ids: any[]): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.http
        .post('api/Invoices/IsValidKnockedoff', { ids: ids }, { _silent: true })
        .subscribe(res => {
          if(res > 0) {
            this.match(ids, res);
            resolve(true);
          }
          else {
            if(res === -1){
              this.msg.error('<b>Invoice(s) is already knocked-off.')
            }
            if(res === -2){
              this.msg.error('<b>Invoice(s) that have been selected have different customer IDs.')
            }
            reject();
          }
        });
    });
  }

  match(row: any[], customerId: any){
    this.router.navigate(['/ar/or/detail/0'], { queryParams: { customerId: customerId, docType: 'INV', toKnockoffBatch: row } });
  }

  batchDelete(ids: any[]): Observable<any> {
    return this.http.delete('api/invoices', null, {
      body: { ids: ids }
    });
  }
  constructor(injector: Injector) {
    super(injector);
  }
}
